import _ from 'lodash';
import I18n from '../../../config/i18n';

export interface OptionsValue {
  value: string | number;
  label: string;
}

const minDurationValue = 1;

export function getDurationOptions(minDuration = minDurationValue): OptionsValue[] {
  const verifiedMinDuration = minDuration < minDurationValue ? minDurationValue : minDuration;
  const emptyValue = { value: '', label: I18n.t('booking.duration') };
  const minWeek = Math.ceil(verifiedMinDuration / 7);
  const weeks = _.range(minWeek, 4).map((nr) => ({
    value: nr * 7,
    label: `${nr} ${I18n.t(nr > 1 ? 'booking.weeks' : 'booking.week')}`,
  }));
  const days = _.range(verifiedMinDuration, 22).map((nr) => ({
    value: nr,
    label: `${nr} ${I18n.t(nr > 1 ? 'booking.nights' : 'booking.night')}`,
  }));
  return [emptyValue, ...weeks, ...days];
}

export function getOccupancyOptions(until = 99): OptionsValue[] {
  return _.range(1, until + 1).map((nr) => ({
    value: nr,
    label: `${nr} ${I18n.t(`web_app_theme.search_${nr > 1 ? 'people' : 'person'}`)}`,
  }));
}

export function getNoRegion(): OptionsValue[] {
  const noRegion = {
    label: I18n.t('search.all_regions'),
    value: '',
  };
  return [noRegion];
}

export function getNoCity(): OptionsValue[] {
  const noCity = {
    label: I18n.t('search.all_cities'),
    value: '',
  };
  return [noCity];
}
